export class SimpleEvent {
    constructor() {
        this._callbacks = [];
    }
    get callbacks() {
        return this._callbacks;
    }
    addListener(callback) {
        this._callbacks.push(callback);
    }
    removeListener(callback) {
        let index = this._callbacks.indexOf(callback);
        if (index != -1) {
            this._callbacks.splice(index, 1);
        }
    }
    hasListener(callback) {
        let index = this._callbacks.indexOf(callback);
        if (index == -1) {
            return false;
        }
        return true;
    }
    removeAt(index) {
        this._callbacks.splice(index, 1);
    }
    removeAllListeners() {
        this._callbacks = [];
    }
    emit(...args) {
        this._callbacks.forEach(element => {
            element(...args);
        });
    }
}
//# sourceMappingURL=SimpleEvent.js.map